import { cn, Field, FieldContent } from "@pdfking/components"
import type { ValidationError } from "@pdfking/forms"
import { CreateRenderFunction } from "@pdfking/reactivity/preact"

import { DjErrors } from "../fields/DjErrors"
import { DjLabel } from "../fields/DjLabel"

/**
 * Column wrapper shared by every field variant: the outer div holds the label/
 * error stack. Inline fields are grid cells (`cell`) sized by the line grid, so
 * they carry no width of their own; a full-width field passes `col` (`w-full`).
 */
export const FieldShell = CreateRenderFunction({
  props: {
    cell: false,
    className: "",
    // Overrides the field_key-derived width when set.
    col: "",
    error: undefined as ValidationError | undefined,
    field_key: "",
    hide_labels: false,
    path: "",
  },
  render(children) {
    const show_label = !this.hide_labels
    const size = this.cell ? "" : this.col
    return (
      <div className={cn(size, this.className)}>
        <Field className="gap-1">
          {show_label ? <DjLabel field_id={this.field_key} path={this.path} /> : undefined}
          <FieldContent className="gap-1">
            <DjErrors error={this.error}>{children}</DjErrors>
          </FieldContent>
        </Field>
      </div>
    )
  },
})
